import PropTypes from 'prop-types'
import classNames from 'classnames'
import { FaEye, FaImage, FaPen, FaShare, FaStar } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'


export function Album(props) {
  const history = useHistory()
  return (
    <div
      onClick={() => history.push(`/compositions/new?albumId=${props.id}`)}
      className={classNames([
        'group relative',
        'cursor-pointer',
        props.className,
      ])}
    >
      <div
        className='
          transition-all
          bg-gradient-to-b
          from-black
          absolute top-0 left-0 right-0 bottom-3/4 z-10
          opacity-80
        '
      />
      <div
        className='
          transition-all
          bg-gradient-to-t
          from-black
          absolute top-3/4 left-0 right-0 bottom-0 z-10
          opacity-50
          lg:opacity-0 lg:group-hover:opacity-50
        '
      />
      <div className='
        group
        transition-all
        absolute left-0 top-0 bottom-0 right-0
        z-10
        flex flex-col
        shadow-lg
      '>
        <h2 className='
          transition-all
          p-3
          text-white font-bold sm:text-lg
          flex items-start space-x-2
        '>
          <span>{props.title}</span>
          <span className='flex-grow flex space-x-1 justify-end text-disabled-400'>
            {
              props.shared &&
              <span className='mt-1'>
                <FaShare />
              </span>
            }
            {
              props.favorite &&
              <span className='text-yellow-400 mt-1'>
                <FaStar />
              </span>
            }
          </span>
        </h2>
        <div className='flex-grow'/>
        <div className='
          transition-all
          p-3
          flex items-center space-x-2
          text-white
          lg:opacity-0 lg:group-hover:opacity-100
        '>
          <a
            href={`/users/${props.createdBy.id}/albums`}
            onClick={(e) => {
              e.preventDefault()
              e.stopPropagation()
              history.push(`/users/${props.createdBy.id}/albums`)
            }}
            className='
              flex-grow overflow-ellipsis overflow-hidden whitespace-nowrap
              transition-all
              text-disabled-200 hover:text-white hover:underline
              p-2
            '
          >
            by {props.createdBy.fullName}
          </a>
          <div
            onClick={e => {
              e.preventDefault()
              e.stopPropagation()
              history.push(`/albums/${props.id}/`)
            }}
            className='base-btn rounded-full bg-primary-600 hover:bg-primary-800 p-2'
          >
            {
              props.permissions.edit || props.permissions.addItems ?
              <FaPen /> :
              <FaEye />
            }
          </div>
        </div>
      </div>
      <div className='aspect-w-10 aspect-h-10 z-0'>
        {
          props.thumbnail ? (
            props.thumbnail.type === 'Image' ?
            <img
              className='w-full h-full object-cover'
              src={props.thumbnail?.small || props.thumbnail?.medium || props.thumbnail.file}
              alt={props.thumbnail.title}
            /> :
            <video
              disableRemotePlayback
              className='w-full h-full object-cover'
              src={props.thumbnail.small || props.thumbnail.medium || props.thumbnail.file}
              autoPlay
              muted
            />
          ) :
          <div className='bg-disabled-400 w-full h-full flex items-center justify-center text-2xl'>
            <FaImage />
          </div>
        }
      </div>
    </div>
  )
}

Album.propTypes = {
  id: PropTypes.string.isRequired,
  thumbnail: PropTypes.object,
  date: PropTypes.string,
  description: PropTypes.string,
  title: PropTypes.string.isRequired,
  createdBy: PropTypes.object.isRequired,
  items: PropTypes.array,
  onClick: PropTypes.func,
  className: PropTypes.string,
  favorite: PropTypes.bool,
  shared: PropTypes.bool,
  permissions: PropTypes.object,
}

Album.defaultProps = {
  authors: [],
}
